class Leimuiden {
  constructor() {
    this.filter = $('select[name=filter-status]');
  }

  init() {
    /**
     * Filter areas when the filter select value changes
     * 
     * @listens change
     */
    this.filter.on('change', (e) => {
      const status = e.currentTarget.value;
      
      this.constructor.filterAreas(status);
    });

    /**
     * Trigger filter change on start up
     */
    this.filter.trigger('change');
  }

  static filterAreas(status) {
    if ($(window).width() < 769) {
      if (status) {
        // Hide all popups
        $('.lot-selector-area-wrap').hide(); // Show matching popups

        $(`.lot-selector-area-wrap.${status}`).show();
      } else {
        // Show all popups
        $('.lot-selector-area-wrap').show();
      }
    }
  }
}

$(document).ready(() => {
  new Leimuiden().init();
});
